import type { AddHeapBoundaryPayload, HeapObj } from './types';

export const updateHeapPayloadMapper = (updatedHeap: HeapObj) => {
  const { bulkDensity, materialType, ...rest } = updatedHeap;
  const res = {
    ...rest,
    bulk_density: bulkDensity,
    material_type: materialType,
  };
  return res;
};

export const addHeapBoundaryPayloadMapper = (
  payload: AddHeapBoundaryPayload,
) => {
  const { bulkDensity, baseReference, baseIteration, materialType, ...rest } =
    payload;

  const result = {
    ...rest,
    bulk_density: bulkDensity,
    base_reference: baseReference,
    base_iteration: baseIteration,
    material_type: materialType,
  };

  return result;
};
